module.exports = __webpack_public_path__ + "static/media/Wonder_Logo_White.4691fc7f.png";